import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';

import Icon from '../Icon';

import theme from './Carousel.scss';

class Carousel extends Component {
  static propTypes = {
    value: PropTypes.array.isRequired,
    defaultSelectedTab: PropTypes.number,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    defaultSelectedTab: 0,
    onClick: noop,
  };

  state = {
    step: 0,
    activeTab: this.props.defaultSelectedTab ? this.props.defaultSelectedTab : 0,
  };

  componentDidMount() {
    this.viewRootWidth =  ReactDOM.findDOMNode(this.root).getBoundingClientRect().width; // eslint-disable-line
    this.viewContainerWidth =  ReactDOM.findDOMNode(this.container).getBoundingClientRect().width; // eslint-disable-line
    this.steps = Math.ceil(this.viewContainerWidth / this.viewRootWidth);
  }

  scrollRight = () => {
    this.setState(({ step }) => ({ step: step + 1 }));
  };

  scrollLeft = () => {
    this.setState(({ step }) => ({ step: step - 1 }));
  };

  calculateScrollSpace = (width, step) => {
    let scrollWidth = 0;
    const spaceLeft = this.viewContainerWidth % width;
    if (step === (this.steps - 1)) {
      scrollWidth = (width * (step - 1)) + spaceLeft;
    } else {
      scrollWidth = width * step;
    }
    return scrollWidth;
  };

  render() {
    const { value, onClick } = this.props;

    return (
      <div
        className={ theme.root }
        ref={ (ref) => this.root = ref }
      >
        { this.state.step !== 0 ?
          <div
            className={ classnames(theme.arrow, theme.leftArrowContainer) }
            onClick={ this.scrollLeft }
          >
            <Icon
              className={ theme.leftArrow }
              name="chevron-down"
            />
          </div> :
          <div />
        }
        <div
          className={ theme.container }
          ref={ (ref) => this.container = ref }
          style={ {
            transform: `translateX(-${ this.calculateScrollSpace(this.viewRootWidth, this.state.step) }px)`,
          } }
        >
          { value.map((item, idx) => (
            <div
              className={ classnames(theme.item, {
                [theme.active]: idx === this.state.activeTab,
              }) }
              key={ `item-${ item }` }
              onClick={ () => {
                this.setState({ activeTab: idx });
                onClick(idx);
              } }
            >
              { item }
            </div>
          )) }
        </div>
        { this.state.step < this.steps - 1 ?
          <div
            className={ classnames(theme.arrow, theme.rightArrowContainer) }
            onClick={ this.scrollRight }
          >
            <Icon
              className={ theme.rightArrow }
              name="chevron-down"
            />
          </div> :
          <div />
        }
      </div>
    );
  }
}

export default Carousel;
